import Search from "./search";

export default function () {
  const obj = new Search();
  obj.init()
  return obj;
}
